<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      size="small"
    >
      <el-form-item :label="$t('user.email.newEmail')" prop="phone">
        <el-input v-model="ruleForm.phone" autocomplete="off" clearable :placeholder="$t('user.email.placeholder.inputEmail')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('user.email.verificationCode')" prop="smsCode" >
        <el-input v-model="ruleForm.smsCode" autocomplete="off" clearable :placeholder="$t('user.email.placeholder.inputCode')">
          <template slot="append">
            <div v-if='codeCd'>{{ $t('user.email.getCodeCountdown', long) }}</div>
            <div v-else @click="sendPhoneCode('ruleForm')">{{ $t('user.email.getCode') }}</div>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item style="text-align: right;">
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">{{ $t('user.email.submit') }}</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">{{ $t('user.email.reset') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { addressAdd, addressUpdate, usersSendCode } from '@/api'
export default {
  data() {
    return {
      ruleForm: {
        phone: "",
        smsCode: "",
      },
      long: 60,
      codeCd: false,
      rules: {
        phone: [
          { required: true, message: this.$t('user.email.requiredMessage.email'), trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: this.$t('user.email.formatMessage.email'), trigger: 'blur' },
        ],
        smsCode: [
          { required: true, message: this.$t('user.email.requiredMessage.smsCode'), trigger: 'blur' },
          { pattern: /^\d{4}$/, message: this.$t('user.email.formatMessage.smsCode'), trigger: 'blur' },
        ],
      },
      id:''
    };
  },
  methods: {
    // 发送验证码
    sendPhoneCode(formName){
      this.$refs[formName].validateField('phone', async (valid) => {
        if (!valid) {
          // 获取验证码
          // captcha(this.form.phone)
          this.getUsersSendCode()
          // 开启计时
          this.codeCd = true
          const timer = setInterval(() => {
            this.long--
            if (this.long <= 0) {
              this.long = 60
              this.codeCd = false
              clearInterval(timer)
            }
          }, 1000)
        } else {
          return false
        }
      })
    },
    // 获取验证码
    getUsersSendCode(){
      usersSendCode({phone:this.ruleForm.phone}).then(res => {
        if(res.code == 1){
          // this.phoneCode = res.data
          this.$message.success(res.msg)
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = this.ruleForm
          if(this.id){
            addressUpdate({
              address_id:this.id,
              user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
              ...form
            }).then(res => {
            if(res.code == 1){
              this.$message.success(res.msg)
              this.$emit('ok')
            }else{
              this.$message.error(res.msg)
            }
          })
          }else{
            addressAdd({
              user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
              ...form
            }).then(res => {
            if(res.code == 1){
              this.$message.success(res.msg)
              this.$emit('ok')
            }else{
              this.$message.error(res.msg)
            }
          })
          }
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.value = []
    },
  },
};
</script>
<style lang="scss" scoped>
  .code{
    font-size: 14px;
    cursor: pointer;
    color: #409EFF;
    margin-left: 10px;
    flex: 1;
    text-align: right;
    width: 100px;
    float: right;
  }
</style>